module.exports = __webpack_public_path__ + "static/car-5c53b576000d3a05616b5046682f9391.svg";